import { render, staticRenderFns } from "./searchGame.vue?vue&type=template&id=012543b6&scoped=true"
import script from "./searchGame.vue?vue&type=script&lang=js"
export * from "./searchGame.vue?vue&type=script&lang=js"
import style0 from "./searchGame.vue?vue&type=style&index=0&id=012543b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012543b6",
  null
  
)

export default component.exports